import PipelineStageDropdown from './pipeline_stage_dropdown.vue';
/**
 * Renders the pipeline stages portion of the pipeline mini graph.
 */ export default {
    name: 'PipelineStages',
    components: {
        PipelineStageDropdown
    },
    props: {
        isMergeTrain: {
            type: Boolean,
            required: false,
            default: false
        },
        stages: {
            type: Array,
            required: true
        }
    },
    emits: [
        'job-action-executed',
        'mini-graph-stage-click'
    ]
};
